import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Package, ShoppingCart, Users, IndianRupee, Clock } from "lucide-react";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
    api.get("/admin/orders", { params: { limit: 6 } }).then((r) => setRecent(r.data));
  }, []);

  const cards = [
    { label: "Revenue", value: stats ? `₹${stats.revenue.toFixed(0)}` : "—", Icon: IndianRupee },
    { label: "Orders", value: stats?.total_orders ?? "—", Icon: ShoppingCart },
    { label: "Pending", value: stats?.pending_orders ?? "—", Icon: Clock },
    { label: "Customers", value: stats?.total_customers ?? "—", Icon: Users },
    { label: "Products", value: stats?.total_products ?? "—", Icon: Package },
  ];

  return (
    <div>
      <div className="kyro-overline">Dashboard</div>
      <h1 className="font-display font-black text-3xl md:text-4xl tracking-tighter mt-2 mb-8">Overview</h1>
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3 mb-8">
        {cards.map((c) => (
          <div key={c.label} className="kyro-card p-5">
            <c.Icon className="w-4 h-4 text-[#FF4433] mb-3" />
            <div className="text-xs text-kyro-mute">{c.label}</div>
            <div className="font-display font-black text-2xl mt-1">{c.value}</div>
          </div>
        ))}
      </div>

      <div className="kyro-card p-6">
        <h2 className="font-display font-bold text-xl mb-4">Recent orders</h2>
        {recent.length === 0 && <p className="text-kyro-mute text-sm">No orders yet.</p>}
        <div className="space-y-2">
          {recent.map((o) => (
            <div key={o.id} className="flex items-center justify-between gap-4 py-3 border-b border-white/5 last:border-0">
              <div className="min-w-0">
                <p className="font-mono text-xs text-kyro-mute">{o.id}</p>
                <p className="text-sm font-semibold truncate">{o.guest_email || o.user_id}</p>
              </div>
              <div className="text-right">
                <p className="font-semibold">₹{o.total.toFixed(0)}</p>
                <p className="text-xs text-kyro-mute uppercase">{o.status}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
